import React, { useState, useEffect } from "react";

import {
  Dialog,
  DialogTitle,
  Typography,
  Button,
  Box,
  Grid,
  TextField,
  DialogContent,
  DialogActions,
  Container,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

// DB接続の際に使用
import axios from "axios";
import ConstList from "../utils/ConstList";

// ログイン情報管理
import { useRecoilValue } from "recoil";
import { LoginUserAtom } from "../stores/LoginUserAtom";

// ロードアイコン
import CircularProgress from "@mui/material/CircularProgress";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

// 入力したデータの更新に使用する
import { Controller, useForm } from "react-hook-form";

// 日付の取得
import "dayjs/locale/ja"; // 日本語ロケールのインポート

type Props = {
  Data: any;
  EditOpen: boolean;
  SetEditOpen: React.Dispatch<React.SetStateAction<boolean>>;
  ReViewPage: React.Dispatch<React.SetStateAction<boolean>>;
  leadSourceList?: any[];
  salesStatusList?: any[];
};

type FormValues = {
  // 表示専用（変更前）
  EX_Companyname: string;
  EX_Businessdescription: string;
  EX_Companytelephone: string;
  EX_Companymail: string;
  EX_Companyaddress: string;
  EX_Companywebsite: string;
  EX_Lead_sources_id: number | "";
  EX_Sales_status_id: number | "";
  EditCompany_id: number;

  // 変更後
  Company_id: number;
  Company_name: string;
  Business_description: string;
  Company_telephone: string;
  Company_mail: string;
  Company_address: string;
  Company_website: string;
  Lead_sources_id: number | "";
  Sales_status_id: number | "";
};

const Pros_customer_Edit = ({
  Data,
  EditOpen,
  SetEditOpen,
  ReViewPage,
  leadSourceList = [],
  salesStatusList = [],
}: Props) => {
  // ログイン - Atom
  const loginUserData = useRecoilValue(LoginUserAtom);

  // 画面の読み込みフラグ
  const [loading, setLoading] = useState<boolean>(true);

  // 変更完了メッセージの表示状態
  const [openSnackbar, setOpenSnackbar] = useState(false);

  // 保存処理中かどうかを管理
  const [isSaving, setIsSaving] = useState(false);

  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // 重複エラー表示
  const [dupSnackbarOpen, setDupSnackbarOpen] = useState(false);
  const [dupMessage, setDupMessage] = useState<string>("");
  const [dupError, setDupError] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      EX_Companyname: "",
      EX_Businessdescription: "",
      EX_Companytelephone: "",
      EX_Companymail: "",
      EX_Companyaddress: "",
      EX_Companywebsite: "",
      EX_Lead_sources_id: "",
      EX_Sales_status_id: "",
      EditCompany_id: 0,

      Company_id: 0,
      Company_name: "",
      Business_description: "",
      Company_telephone: "",
      Company_mail: "",
      Company_address: "",
      Company_website: "",
      Lead_sources_id: "",
      Sales_status_id: "",
    },
  });

  // ###################################################################
  // #################### 画面を開いたとき ###########################
  // ###################################################################

  useEffect(() => {
    if (!EditOpen || !Data) return;

const init = async () => {
  setLoading(true);

  reset({
    EX_Companyname: Data.Company_name ?? "",
    EX_Businessdescription: Data.Business_description ?? "",
    EX_Companytelephone: Data.Company_telephone ?? "",
    EX_Companymail: Data.Company_mail ?? "",
    EX_Companyaddress: Data.Company_address ?? "",
    EX_Companywebsite: Data.Company_website ?? "",
    EX_Lead_sources_id: Data.Lead_sources_id ?? "",
    EX_Sales_status_id: Data.Sales_status_id ?? "",
    EditCompany_id: Number(Data.Company_id ?? 0),

    Company_id: Number(Data.Company_id ?? 0),
    Company_name: Data.Company_name ?? "",
    Business_description: Data.Business_description ?? "",
    Company_telephone: Data.Company_telephone ?? "",
    Company_mail: Data.Company_mail ?? "",
    Company_address: Data.Company_address ?? "",
    Company_website: Data.Company_website ?? "",
    Lead_sources_id: Data.Lead_sources_id ?? "",
    Sales_status_id: Data.Sales_status_id ?? "",
  });

  setDupSnackbarOpen(false);
  setDupMessage("");
  setDupError(false);

  // これを追加
  setLoading(false);
};

    init();
  }, [EditOpen, Data, reset]);



  // ###################################################################
  // #################### 保存ボタン押したとき ###########################
  // ###################################################################

  const onSubmit = async (data: FormValues) => {
    if (isSaving) return;

    setIsSaving(true);

    const SaveArray = {
      Company_id: data.Company_id,
      Company_name: data.Company_name,
      Business_description: data.Business_description,
      Company_telephone: data.Company_telephone,
      Company_mail: data.Company_mail,
      Company_address: data.Company_address,
      Company_website: data.Company_website,

      // 営業に至ったきっかけ
      lead_sources_id:
        data.Lead_sources_id === "" ? null : Number(data.Lead_sources_id),

      // 現在の営業進捗状況
      sales_status_id:
        data.Sales_status_id === "" ? null : Number(data.Sales_status_id),
    };

    try {
      const postData = {
        flag: "EditProsCustomerInfo",
        access_token: loginUserData.accessToken,
        algorithm: loginUserData.algorithm,
        SaveData: SaveArray,
        UserId: loginUserData.userId,
      };

      console.log("顧客編集送信データ", postData);

      axios
        .post(
          ConstList.getApiUrl() + "EditProsCustomers.php",
          postData,
          ConstList.AXIOS_CONFIG
        )
        .then((response) => {
          console.log("顧客編集結果", response.data);

          if (response.data.message !== "Auth認証失敗") {
            if (response.data.message === "メンテナンス中") {
              window.location.href = "./maintenance";
            } else {
              if (response.data.message === "登録成功") {
                console.log("保存成功");

                ReViewPage(true);

                setOpenSnackbar(true);
                setTimeout(() => {
                  setIsSaving(false);
                  setOpenSnackbar(false);
                  SetEditOpen(false);
                }, 1000);
              } else {
                console.log("保存失敗");
                setDupMessage(response.data.message || "保存に失敗しました。");
                setDupSnackbarOpen(true);
                setIsSaving(false);
              }
            }
          } else {
            alert("エラー：Auth0認証失敗");
            console.log("エラー：Auth0認証失敗");
            setIsSaving(false);
          }
        })
        .catch((error) => {
          alert("エラー：保存");
          console.log(error);
          setIsSaving(false);
        });
    } catch (error) {
      console.error("保存処理でエラーが発生しました：", error);
      alert("保存処理でエラーが発生しました。");
      setIsSaving(false);
    }
  };

  // ##################################################################
  // ################ キャンセルボタン押したとき ########################
  // ##################################################################

  const handleCancel = () => {
    setIsSaving(false);
    SetEditOpen(false);
  };

  // ##################################################################
  // ################ 実際に表示させている画面 ##########################
  // ##################################################################

  return (
      <Dialog
        open={EditOpen}
        fullWidth
        maxWidth="lg"
        scroll="paper"
        PaperProps={{
          sx: {
            height: "90vh",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: 3,
            backgroundColor: "#FFFFFF",
            color: "#111827",
            border: "none",
            boxShadow: "0 24px 64px rgba(15,23,42,0.18)",
          },
        }}
      >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "#374151",
          color: "#FFFFFF",
          borderBottom: "1px solid rgba(255,255,255,0.16)",
        }}
      >
        <BusinessOutlinedIcon sx={{ color: "#FFFFFF" }} />
        <Typography component="span" fontWeight={800}>
          顧客情報の更新
        </Typography>
      </DialogTitle>

      <Box
        sx={{
          position: "sticky",
          top: 48,
          bgcolor: "secondary.main",
          color: "secondary.contrastText",
          zIndex: 1,
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
          顧客情報の更新
        </Typography>
      </Box>

      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <DialogContent dividers sx={{ maxHeight: "70vh", overflowY: "auto" }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress />
              <p className="mt-2 text-sm text-gray-500">読み込み中...</p>
            </Box>
          ) : (
            <Container
              sx={{
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#787a73",
                },
              }}
            >
              <Grid container spacing={2}>
                {/* 変更前の会社名 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の会社名称"
                    value={Data?.Company_name ?? ""}
                  />
                </Grid>

                {/* 変更後の会社名 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後会社名称"
                    error={dupError || !!errors.Company_name}
                    helperText={
                      dupError
                        ? "同じ会社名称は登録できません"
                        : errors.Company_name?.message
                    }
                    {...register("Company_name", {
                      required: "会社名称は必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前の業種 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の業種"
                    value={Data?.Business_description ?? ""}
                  />
                </Grid>

                {/* 変更後の業種 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後業種"
                    error={dupError || !!errors.Business_description}
                    helperText={
                      dupError
                        ? "同じ業種名称は登録できません"
                        : errors.Business_description?.message
                    }
                    {...register("Business_description", {
                      required: "業種名称は必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前の電話番号 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の電話番号"
                    value={Data?.Company_telephone ?? ""}
                  />
                </Grid>

                {/* 変更後の電話番号 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後電話番号"
                    error={dupError || !!errors.Company_telephone}
                    helperText={
                      dupError
                        ? "同じ電話番号は登録できません"
                        : errors.Company_telephone?.message
                    }
                    {...register("Company_telephone", {
                      required: "電話番号は必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前のメールアドレス */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前のメールアドレス"
                    value={Data?.Company_mail ?? ""}
                  />
                </Grid>

                {/* 変更後のメールアドレス */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後メールアドレス"
                    error={dupError || !!errors.Company_mail}
                    helperText={
                      dupError
                        ? "同じメールアドレスは登録できません"
                        : errors.Company_mail?.message
                    }
                    {...register("Company_mail", {
                      required: "メールアドレスは必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前の住所 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の住所"
                    value={Data?.Company_address ?? ""}
                  />
                </Grid>

                {/* 変更後の住所 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後住所"
                    error={dupError || !!errors.Company_address}
                    helperText={
                      dupError
                        ? "同じ住所は登録できません"
                        : errors.Company_address?.message
                    }
                    {...register("Company_address", {
                      required: "住所は必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前のホームページ */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前のサイトURL"
                    value={Data?.Company_website ?? ""}
                  />
                </Grid>

                {/* 変更後のホームページ */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    label="変更後サイトURL"
                    error={dupError || !!errors.Company_website}
                    helperText={
                      dupError
                        ? "同じサイトURLは登録できません"
                        : errors.Company_website?.message
                    }
                    {...register("Company_website", {
                      required: "サイトURLは必須です",
                      onChange: () => setDupError(false),
                    })}
                  />
                </Grid>

                {/* 変更前の営業に至ったきっかけ */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の営業に至ったきっかけ"
                    value={Data?.Lead_sources ?? ""}
                  />
                </Grid>

                {/* 変更後の営業に至ったきっかけ */}
                <Grid size={{ xs: 6 }}>
                  <Controller
                    name="Lead_sources_id"
                    control={control}
                    rules={{
                      required:
                        leadSourceList.length > 0
                          ? "営業に至ったきっかけは必須です"
                          : false,
                    }}
                    render={({ field }) => (
                      <FormControl fullWidth error={!!errors.Lead_sources_id}>
                        <InputLabel id="lead-sources-edit-label">
                          変更後の営業に至ったきっかけ
                        </InputLabel>

                        <Select
                          labelId="lead-sources-edit-label"
                          label="変更後の営業に至ったきっかけ"
                          value={field.value === "" ? "" : String(field.value)}
                          onChange={(e) => {
                            const value = String(e.target.value);
                            field.onChange(value === "" ? "" : Number(value));
                          }}
                          MenuProps={selectMenuProps}
                        >
                          <MenuItem value="">
                            <em>未選択</em>
                          </MenuItem>

                          {leadSourceList.map((item: any) => (
                            <MenuItem
                              key={item.lead_sources_id}
                              value={String(item.lead_sources_id)}
                            >
                              {item.lead_sources}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {errors.Lead_sources_id?.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>

                {/* 変更前の営業進捗状況 */}
                <Grid size={{ xs: 6 }}>
                  <TextField
                    fullWidth
                    disabled
                    label="変更前の営業進捗状況"
                    value={Data?.Sales_status ?? ""}
                  />
                </Grid>

                {/* 変更後の営業進捗状況 */}
                <Grid size={{ xs: 6 }}>
                  <Controller
                    name="Sales_status_id"
                    control={control}
                    rules={{
                      required:
                        salesStatusList.length > 0
                          ? "営業進捗状況は必須です"
                          : false,
                    }}
                    render={({ field }) => (
                      <FormControl fullWidth error={!!errors.Sales_status_id}>
                        <InputLabel id="sales-status-edit-label">
                          変更後の営業進捗状況
                        </InputLabel>

                        <Select
                          labelId="sales-status-edit-label"
                          label="変更後の営業進捗状況"
                          value={field.value === "" ? "" : String(field.value)}
                          onChange={(e) => {
                            const value = String(e.target.value);
                            field.onChange(value === "" ? "" : Number(value));
                          }}
                          MenuProps={selectMenuProps}
                        >
                          <MenuItem value="">
                            <em>未選択</em>
                          </MenuItem>

                          {salesStatusList.map((item: any) => (
                            <MenuItem
                              key={item.sales_status_id}
                              value={String(item.sales_status_id)}
                            >
                              {item.sales_status}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {errors.Sales_status_id?.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </Container>
          )}
        </DialogContent>

        <DialogActions sx={{ mt: 1 }}>
          <Button
            onClick={handleCancel}
            disabled={isSaving}
            variant="outlined"
            color="primary"
          >
            キャンセル
          </Button>

          <Button
            type="submit"
            disabled={isSaving}
            variant="contained"
            color="primary"
          >
            {isSaving ? (
              <CircularProgress size={24} sx={{ color: "inherit" }} />
            ) : (
              "更新"
            )}
          </Button>
        </DialogActions>
      </Box>

      <Snackbar
        open={dupSnackbarOpen}
        autoHideDuration={2000}
        onClose={() => setDupSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="warning" onClose={() => setDupSnackbarOpen(false)}>
          {dupMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={1000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success">変更処理が完了しました。</Alert>
      </Snackbar>
    </Dialog>
  );
};

const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 48 * 5 + 8,
      overflowY: "auto",
      borderRadius: 2,
      mt: 0.5,
    },
  },
};

export default Pros_customer_Edit;
